import React, { useEffect } from 'react';
import { Router, Switch, Route } from "react-router-dom";
import DashBoard from './DashBoard/DashBoard';

import LandingPage from './LandingPage/LandingPage';
import LeaderBoard from './LeaderBoard/LeaderBoard';
import Quiz from './Quiz/Quiz';
import Navbar from './Navbar/Navbar';
import history from './history';
import Portfolio from './Portfolio/Portfolio';
import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles';


import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { isWebTokenValid } from '../actions';
import { CssBaseline } from '@material-ui/core';
import { lightBlue } from '@material-ui/core/colors';
import AboutPage from './AboutPage/AboutPage';
import StudyCorner from './StudyCorner/StudyCorner';





let theme = createMuiTheme({
    palette: {
        primary: lightBlue,

        type: 'dark'
    }

})

theme = responsiveFontSizes(theme);





const App = (props) => {
    const isSignedIn = useSelector((state) => state.auth.isSignedIn);
    const dispatch = useDispatch();
    useEffect(() => {
        let token = localStorage.getItem("auth-token");
        if (token === null) {
            localStorage.setItem("auth-token", "");
            token = "";
        }
        if (!isSignedIn ) {
            dispatch(isWebTokenValid(token));
        }
    }, [isSignedIn, dispatch]);



    return (
        <>
            <Router history={history}>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    {isSignedIn ? <Navbar /> : null}
                    <Switch>
                        <Route path="/" exact component={LandingPage} />
                        <Route path="/dashboard" exact component={DashBoard} />
                        <Route path="/leaderBoard" exact component={LeaderBoard} />
                        <Route path="/quiz" exact component={Quiz} />
                        <Route path='/portfolio' exact component={Portfolio} />
                        <Route path='/about' exact component={AboutPage} />
                        <Route path='/studyCorner' exact component={StudyCorner} />
                    </Switch>
                </ThemeProvider>
            </Router>
        </>
    )
}


export default App;